import { render, staticRenderFns } from "./HSCodesTable.vue?vue&type=template&id=1b9948c4&scoped=true"
import script from "./HSCodesTable.vue?vue&type=script&lang=js"
export * from "./HSCodesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9948c4",
  null
  
)

export default component.exports